// src/components/atoms/landing/star-rating.tsx
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

type StarRatingProps = {
  value: number;
  max?: number;
  size?: "sm" | "md";
  className?: string;
  ariaLabel?: string;
};

const sizeClass = {
  sm: "size-4",
  md: "size-5",
} as const;

export function StarRating({
  value,
  max = 5,
  size = "md",
  className,
  ariaLabel,
}: StarRatingProps) {
  const clamped = Math.max(0, Math.min(value, max));
  const label = ariaLabel ?? `${clamped} out of ${max} stars`;

  return (
    <span
      role="img"
      aria-label={label}
      className={cn("inline-flex items-center gap-1", className)}
    >
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < Math.floor(clamped);
        return (
          <Star
            key={i}
            aria-hidden
            className={cn(
              sizeClass[size],
              filled
                ? "fill-amber-400 text-amber-400"
                : "fill-transparent text-amber-400/40",
            )}
            strokeWidth={1.5}
          />
        );
      })}
    </span>
  );
}
